import { Column, Id } from "@silevis/reactgrid";

export const mapColumnsToSpreadsheetColumns = (columns: Array<string>): Array<Column> =>
    columns.map((columnId) => ({
        columnId,
        reorderable: true,
        resizable: true,
    }));

export const resizeColumn = ({
    columns,
    columnId,
    width,
}: {
    columns: Array<Column>;
    columnId: Id;
    width: number;
}): Array<Column> => {
    // Find the index of the column being resized
    const columnIndex = columns.findIndex((column) => column.columnId === columnId);

    // Get the column being resized and update its width
    const resizedColumn = columns[columnIndex];
    const updatedColumn = {
        ...resizedColumn,
        width,
        columnId,
    };

    // Create a new array with the updated column and return it
    columns[columnIndex] = updatedColumn;
    return [...columns];
};
